import styled from "styled-components";
import CountdownTimer from "react-component-countdown-timer";

export const CountdownWrapper = styled(CountdownTimer)``; 
